var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import 'dayjs/locale/pl';
import FormControl from '@mui/material/FormControl';
import { Controller } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { plPL } from '@mui/x-date-pickers/locales';
import dayjs from 'dayjs';
var localeText = __assign(__assign({}, plPL.components.MuiLocalizationProvider.defaultProps.localeText), { fieldYearPlaceholder: function (_a) {
        var digitAmount = _a.digitAmount;
        return 'R'.repeat(digitAmount);
    }, fieldMonthPlaceholder: function () { return 'MM'; }, fieldDayPlaceholder: function () { return 'DD'; } });
export function FormDatePicker(_a) {
    var name = _a.name, slotProps = _a.slotProps, label = _a.label, props = __rest(_a, ["name", "slotProps", "label"]);
    return (_jsx(Controller, { name: name, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            var valueAsDayjs = field.value ? dayjs(field.value) : null;
            return (_jsx(FormControl, { error: Boolean(fieldState.error), fullWidth: true, children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: "pl", localeText: localeText, children: _jsx(DatePicker, __assign({ label: label }, field, props, { slotProps: __assign(__assign({}, slotProps), { textField: __assign({ error: Boolean(fieldState.error), helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField) }), value: valueAsDayjs })) }) }));
        } }));
}
